'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExpandableList = require('./components/ExpandableList.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpandableList).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/expandable/lib/components/expandable-list/index.js
// module id = 1409
// module chunks = 1